/**
 * External dependencies
 */
import styled from '@emotion/styled';

export const CalendarHelp = styled.div`
	min-width: 260px;
`;
